import { IImageContent } from "../../../../documaker/domain/format/objects";
import { IPropertyEditable, instanceOfIPropertyEditable, IPropertyPresentable, instanceOfIPropertyPresentable } from "../../../../base/domain/system/edit";

export interface IImageContentPropertyEditable {
  formatId(): IPropertyPresentable<number>;
  imageContent(): IPropertyPresentable<IImageContent>;
  temporaryImageContent(): IPropertyEditable<IImageContent>;
}

export function instanceOfIImageContentPropertyEditable(instance: any): instance is IImageContentPropertyEditable {
  return instance
      && instance.formatId
      && instance.imageContent
      && instance.temporaryImageContent
      && instanceOfIPropertyPresentable<number>(instance.formatId())
      && instanceOfIPropertyPresentable<IImageContent>(instance.imageContent())
      && instanceOfIPropertyEditable<IImageContent>(instance.temporaryImageContent());
}
